import { Observable, filter } from "rxjs";

export function filterOutFalsyValues(){
    return function<T>(source: Observable<T>) {
      return source.pipe(filter(value => !!value));
    }
  }